import React, { useState, useEffect } from "react";
import "./CaseStudies.css";
import { Play } from "lucide-react";
import dlu from "../../assets/images/dlu.png";
import redshift from "../../assets/images/redshift.png";

const fetchCaseStudies = async () => {
  return [
    {
      id: 1,
      title:
        "Driving Data-Driven Decisions with Redshift: A Cloud-Native Migration Journey",
      description:
        "Idexcel implemented an automated, scalable, and cost-effective data pipeline on AWS—enabling faster insights, better reporting, and seamless analytics at scale.",
      imageUrl: dlu,
        link:"resources/case-studies/DLU-CaseStudy.pdf",
    },
    {
      id: 2,
      title: "Optimizing Data Management and Scalability with AWS Redshift",
      description:
        "Streamlining data processing and enhancing decision-making capabilities through a fully automated, scalable cloud data warehousing solution.",
      imageUrl: redshift,
        link:"resources/case-studies/Redshift-Migration-for-Loan-Origination-System.pdf",
    },

  ];
};

const CaseStudyCard = ({ title, description, imageUrl, link }) => {
  return (
    <div className="data-case-study-card">
      <img src={imageUrl} alt={title} className="case-study-image" />
      <div className="data-overlay">
        <div className="data-text-content">
          <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
            {" "}
            <a href={link} target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
            <h2>{title}</h2>
            </a>
            <a href={link} target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
            <Play size={40} /></a>
          </div>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

const CaseStudies = () => {
  const [caseStudies, setCaseStudies] = useState([]);

  useEffect(() => {
    fetchCaseStudies().then((data) => setCaseStudies(data));
  }, []);

  return (
    <div className="databg">
    <h1 className="text-center mb-4 section-title">
            Customer Success Stories
          </h1>
    <div className="data-case-studies-container">
      <div className="data-case-studies-grid">
        {caseStudies.map((cs) => (
          <CaseStudyCard key={cs.id} {...cs} />
        ))}
      </div>
    </div>
    </div>
  );
};

export default CaseStudies;
